import { Skeleton } from '../../Skeleton'

import * as styles from './FileListItemSkeleton.module.css'

function FileListItemSkeleton({ className = styles.FileListItemSkeleton }) {
  return <Skeleton className={className} />
}

export default FileListItemSkeleton
